import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";

import { ColumnProps } from './CellColumnProps';

export type Getter<T> = (datum: T) => any;
export type Setter<T> = (datum: T, value: any) => void;
export type ItemSourceFn<T, TItem> = (datum: T, draft: Readonly<{[key: string]: any}> ) => TItem[];

export interface DataGridProps
{
    initialData: Array<any>;
    onThead?: (thead: HTMLTableSectionElement) => void;
}

interface DataGridState
{
    data: Array<any>;
}

// DataGrid component helps to create grids on each Entity page inside our app
// Also it applies Bootstrap classes in order to style the grid
// DataGrid makes it easy to specify each grid declaratively as a set of columns 
export class DataGrid extends React.Component<DataGridProps & React.HTMLAttributes<HTMLTableElement>, DataGridState>
{
    constructor(props: DataGridProps)
    {
        super(props);
        this.state = this.getStateFromProps(props);
    }

    componentWillReceiveProps(nextProps: Readonly<DataGridProps>)
    {
        this.setState(this.getStateFromProps(nextProps));
    }

    private getStateFromProps (props: Readonly<DataGridProps>)
    {
        return {
            data: Array.from(props.initialData),
        }
    }

    render ()
    {
        const contexts = this.getContexts();
        const { state } = this;
        const { initialData, className, onThead, ...tableProps} = this.props;

        // Create table element. Populate header first.
        // Iterate over each data item and build one cell at a time
        return (
            <table className={classnames('table table-striped table-bordered table-hover', className)} {...tableProps}>
                <thead ref={onThead}>
                    <tr>
                    {
                        contexts.map((ctx, idx) => {
                            const { header, renderHeader, headerClassName, headerBgColor, headerTextColor } = ctx.props;
                            const content = header ? header : renderHeader();
                            return <th key={idx} style={{background: headerBgColor, color: headerTextColor}} className={classnames('text-center', headerClassName)}>{content}</th>;
                        })
                    }
                    </tr>
                </thead>
                <tbody>
                {
                    state.data.map((datum, rowIdx) => (
                        <tr key={rowIdx}>
                        {
                            // each Column knows how to render a cell from datum
                            React.Children.toArray(this.props.children)
                                .filter(ch => ch != null)
                                .map(ch => React.cloneElement(ch as React.ReactElement<any>, { datum, row: rowIdx }))
                        }
                        </tr>
                    ))
                }
                </tbody>
            </table>
        );
    }

    private getContexts ()
    {
        // convert each child Column component into plain js object
        return React.Children.toArray(this.props.children)
            .filter(item => item != null)
            .map((child,idx) => this.getColumnContext(child));
    }

    private getColumnContext (child: React.ReactChild): ColumnContext
    {
        const elem = child as React.ReactElement<ColumnProps>;
        const column = (elem.type as any) as IDataGridColumnClass; // is there a better way?

        return {
            column: column,
            props: elem.props
        };
    }
}

interface ColumnContext
{
    column: IDataGridColumnClass;
    props: ColumnProps;
}

interface IDataGridColumnClass
{
    getCellTemplate: (columnProps: ColumnProps) => new() => React.Component<any, any>;
}


// WEBPACK FOOTER //
// ./src/components/DataGrid/DataGrid.tsx